module.exports = __webpack_public_path__ + "img/favicon-reader.ca61220f.png";